import { AutocompleteService } from "./interfaces";

export class GoogleAutocompleteService implements AutocompleteService {
    attachAutocomplete(input: HTMLInputElement): void {
        if (typeof google === 'undefined' || !google.maps || !google.maps.places) {
            console.warn('Google Maps JS API not loaded');
            return;
          }
      
          if (input.dataset.autoinited === 'true') {
            return;
          }

          const autocomplete = new google.maps.places.Autocomplete(input, {
            types: ['geocode'],
          });
          autocomplete.setFields(['formatted_address', 'address_components']);
      
          input.dataset.autoinited = 'true';
    }
}